// extracted by mini-css-extract-plugin
export default {"wrapper":"SaveProjectModal_wrapper__ti6Js","title":"SaveProjectModal_title__mVJ3x","text":"SaveProjectModal_text__GwfFH","buttonWrapper":"SaveProjectModal_buttonWrapper__wZMfH"};